var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0 align-start"},[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"12"}},[_c('navTabs')],1)],1),_c('v-container',{staticClass:"fill-height align-center"},[_c('sys-references-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }